<template>
    <div id="main-grid" class="grid simple main borderRadius12px" style="background: #e5e9ec">
      <div class="well form-group" style="background: #e5e9ec">
  
        <!-- title -->
        <div class="grid-title no-border borderTop" style="display: flex; justify-content: space-between; align-items: center; padding-right: 20px;">
          <h4 style="padding-left: 6px"> {{ i18nValues["userAdmin"] }} </h4>
          <el-button 
            v-if="componentsMap.get('user_create')" 
            icon="fas fa-plus" 
            size="small" 
            class="btn-primary" 
            @click="add()"
          > 
            {{ i18nValues["add"] }} 
          </el-button>
        </div>  
      
        <!-- form -->
        <div class="grid-body no-border borderBottom">
          <el-form v-loading="loading != 0">
            <div class="filters-wrapper">
              <div class="filters-row">           
  
                <!-- search by name -->
                <el-form-item :label="i18nValues['name']" prop="name">
                  <el-input v-model="filter.name" :placeholder="i18nValues['name']"></el-input>
                </el-form-item> 

                <!-- search by UserId -->
                <el-form-item :label="i18nValues['user']" prop="userId">
                  <el-input v-model="filter.userId" :placeholder="i18nValues['user']"></el-input>
                </el-form-item>    
                
                <!-- search button  -->
                <el-button
                  @click="retrieveUsersBySearch()"
                  icon="fas fa-search"
                  id="searchButton"
                  size="small"
                  class="btn-primary"
                >
                  {{ i18nValues["search"] }}
                </el-button>
              </div>
            </div>
  
            <!-- table -->
            <el-form-item prop="users">
              <div style="margin:5 auto;padding:15px; width: 100%;">
                  <el-table
                    :key="tableSortKey"
                    :data="UsersSubList"
                    id="UsersTable"
                    class="table table-hover"
                    align="left"
                    with="20%"
                    :empty-text="i18nValues['noDataAvailable']"
                    :default-sort="tableDefaultSort"
                    stripe
                    @sort-change="handleSortChange"
                  >
  
                    <!-- User Name -->
                    <el-table-column
                      prop="name" 
                      :label= "i18nValues['name']"
                      width="75"
                      align="left"
                      sortable
                    ></el-table-column>
  
                    <el-table-column
                      prop="userId" 
                      :label= "i18nValues['user']"
                      width="75"
                      align="left"
                      sortable
                    ></el-table-column>
                    
                    <el-table-column
                      prop="profilesDisplay"
                      :label="i18nValues['profiles']"
                      :formatter="profilesFormatter"
                      width="75"
                      align="left"
                      sortable
                    ></el-table-column>
  
                    <!-- EDIT/DELETE -->
                    <el-table-column width="90" align="right">
                      <template slot-scope="scope">
                        <el-button v-if="componentsMap.get('user_modification')" 
                          class="text-info"
                          icon="fas fa-edit"
                          size="small"
                          :title="i18nValues['edit']"
                          @click="edit(scope.row.userId)"
                        ></el-button>
  
                        <el-button v-if="componentsMap.get('user_delete')" 
                          class="text-danger"
                          icon="fas fa-times"
                          size="small"
                          :title="i18nValues['remove']"
                          @click="deleteUser(scope.row.userId)"
                        ></el-button>
                      </template>
                     </el-table-column>                  
                </el-table>
                <div v-if="90 > 10" style="height: 15px"></div>
                  <div class="pagination-bar">
                    <PaginationFunctional
                      ref="pagination"
                      sublistName="UsersSubList"
                      :fullList="UsersList"
                      :tableSize="20"
                      :tableIndexInitial="initialPage"
                      @paginationChange="paginationChange"
                      @currentIndexPagination="setCurrentPage"
                      class="text-center"
                    /> 
                    <div v-if="UsersList.length > 0" class="results-info">
                      <p>
                        {{ i18nValues["showing"] || "Showing" }} {{ startIndexDisplay }}–{{ endIndexDisplay }} {{ i18nValues["of"] || "of" }} {{ totalRecords }} {{ i18nValues["results"] || "results" }}
                      </p>
                    </div>
                  </div>
              </div>
            </el-form-item>  
  
          </el-form>

        </div>
  
      </div>
    </div>
  </template>
  
  <script>
  import { sync, get } from "vuex-pathify"; // eslint-disable-line no-unused-vars
  import PaginationFunctional from "@/components/PaginationFunctional.vue"
  export default {
    name: "UserAdmin",
  created() {
      this.restoreFromQuery();
      this.runInitialSearch({ preservePage: true });
      this.retrieveUserCount();
    },
  
    components: {
      PaginationFunctional 
    },
  
    computed: {
      loading: get("user/loading"),
      selectedLanguage: get("i18nStore/selectedLanguage"),

      // Pagination helpers for results label
      currentPage() {
        if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) {
          return this.$refs.pagination.tableIndex;
        }
        return this.initialPage || 1;
      },
      pageSize() {
        return 20; // Keep in sync with PaginationFunctional :tableSize
      },
      totalRecords() {
        if (Array.isArray(this.UsersList)) {
          return this.UsersList.length;
        }
        return typeof this.cantidad === "number" ? this.cantidad : 0;
      },
      startIndexDisplay() {
        if (this.totalRecords === 0) return 0;
        const start = (this.currentPage - 1) * this.pageSize + 1;
        return Math.min(start, this.totalRecords);
      },
      endIndexDisplay() {
        if (this.totalRecords === 0) return 0;
        const end = this.currentPage * this.pageSize;
        return Math.min(end, this.totalRecords);
      },

      tableDefaultSort() {
        if (this.sortProp && this.sortOrder) {
          return { prop: this.sortProp, order: this.sortOrder };
        }
        return {};
      },

      tableSortKey() {
        // Key changes when sort changes, forcing table to re-render with new default-sort
        return `${this.sortProp || 'none'}-${this.sortOrder || 'none'}`;
      },
    },

    watch: {
      i18nValues: {
        handler() {
          this.retrieveUsers({
            preservePage: true,
            targetPage: this.initialPage || 1,
          });
        },
        deep: true,
      },
      $route() {
        if (this.isUpdatingRoute) {
          return;
        }
        this.restoreFromQuery();
        this.$nextTick(() => {
          this.runInitialSearch({ preservePage: true });
        });
      },
    },

  
    props:{
      componentsMap: {},
    },
  
    data() {
      return {
        filter: {
          name: null,
          userId: null,
        },
  
        UsersList: [],
        UsersSubList: [],
        cantidad: 100,

        initialPage: 1,
        sortProp: null,
        sortOrder: null,
        isUpdatingRoute: false,
      };
    },
  
    methods: {
      retrieveUsers({ preservePage = false, targetPage = null } = {}) {
        this.$store.dispatch("user/retrieveUsers").then((res) => {
          let processedList = res;
          this.updateProfilesWithNewI18n(processedList);
          // Apply sorting if sort parameters are present (before setting UsersList)
          if (this.sortProp && this.sortOrder && this.$refs && this.$refs.pagination) {
            const sorted = this.$refs.pagination.handleSortChangePagination({
              prop: this.sortProp,
              order: this.sortOrder
            }, processedList);
            if (Array.isArray(sorted)) {
              processedList = sorted;
            } else {
              // Fallback to local sort if pagination component doesn't return array
              processedList = this.sortUsersLocally(processedList, this.sortProp, this.sortOrder);
            }
          }
          // Set the processed list
          this.UsersList = processedList;
          
          // Sync pagination after loading - use double nextTick to ensure pagination component has processed the list
          const resolvedTarget = typeof targetPage === "number" && targetPage > 0
            ? targetPage
            : this.initialPage || 1;
          this.$nextTick(() => {
            this.$nextTick(() => {
              if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
                this.$refs.pagination.currentChange(resolvedTarget);
              }
            });
          });
          // Only update route query if not preserving page (to avoid overwriting URL params during initial load)
          if (!preservePage) {
            this.updateRouteQuery();
          }
          // When preservePage is true, the URL already has the correct state, so we don't update it
        });
      },
  
      retrieveUsersBySearch(preservePage = false) {
        if (this.filter) {
          if (this.filter.name === "") {
            this.filter.name = null;
          }
          if (this.filter.userId === "") {
            this.filter.userId = null;
          }
        }
        if(this.filter == null || ((!this.filter.name || this.filter.name === "") && (!this.filter.userId || this.filter.userId === ""))){
          this.retrieveUsers({ preservePage });
        } else { 
          //console.log(this.filter);//eslint-disable-line
          this.$store.dispatch("user/retrieveUsersBySearch" , this.filter).then((res) => {
            let processedList = res;
            this.updateProfilesWithNewI18n(processedList);
            
            // Apply sorting if sort parameters are present
            if (this.sortProp && this.sortOrder && this.$refs && this.$refs.pagination) {
              const sorted = this.$refs.pagination.handleSortChangePagination({
                prop: this.sortProp,
                order: this.sortOrder
              }, processedList);
              if (Array.isArray(sorted)) {
                processedList = sorted;
              } else {
                // Fallback to local sort if pagination component doesn't return array
                processedList = this.sortUsersLocally(processedList, this.sortProp, this.sortOrder);
              }
            }
            
            this.UsersList = processedList;
            
            const targetPage = preservePage ? this.initialPage || 1 : 1;
            if (!preservePage) {
              this.initialPage = 1;
            }
            
            // Sync pagination after loading
            this.$nextTick(() => {
              this.$nextTick(() => {
                if (this.$refs && this.$refs.pagination && typeof this.$refs.pagination.currentChange === "function") {
                  this.$refs.pagination.currentChange(targetPage);
                }
              });
            });
            
            // Update URL after search
            if (preservePage) {
              this.updateRouteQuery();
            } else {
              this.updateRouteQuery({ page: 1 });
            }
          });
        }
      },

      updateProfilesWithNewI18n(list = null) {
          const usersList = list || this.UsersList;
          usersList.forEach(user => {
              user.profiles.forEach(profile => {
                  if (profile.identification === 'Limpieza Silo') {
                      profile.identification = this.i18nValues["siloCleaning"];
                  }

                  if (profile.identification === 'Administrador') {
                      profile.identification = this.i18nValues["administrator"];
                  }

                  if (profile.identification === 'Producción Campo') {
                      profile.identification = this.i18nValues["fieldProduction"];
                  }

                  if (profile.identification === 'Producción Total') {
                      profile.identification = this.i18nValues["totalProduction"];
                  }

                  if (profile.identification === 'Producción Planta') {
                      profile.identification = this.i18nValues["plantProduction"];
                  }

                  if (profile.identification === 'Producción IA') {
                      profile.identification = this.i18nValues["aiProduction"];
                  }
              });
              // Precompute a display string for profiles to enable proper sorting
              user.profilesDisplay = user.profiles
                .map(profile => profile.identification)
                .join(", ");
          });
      },

      add() {
        this.$router.push({
          name: `UserEdition`,
          params: { id: "0" },
        query: this.$route.query,
        });
      },
  
      edit(userId) {
        this.$router.push({
          name: `UserEdition`,
          params: { userId: userId },
        query: this.$route.query,
        });
      },
  
      deleteUser(id) {
        this.$confirm('Está seguro que quiere eliminar el usuario?', 'Eliminar Usuario', {
                distinguishCancelAndClose: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar',
                type: 'warning'
            }).then(() => {
              this.$store.dispatch("user/deleteUser" , id).then((res)=>{
                if (res.status == "OK") {
                  this.$notify.success({
                    title: this.i18nValues["success"],
                    message: this.i18nValues["userDeleted"],
                    position: "bottom-right",
                  });
                  // After delete, reload using current filters/sort and keep pagination state
                  this.runInitialSearch({ preservePage: true });
                  this.retrieveUserCount();
                } else {
                  this.$notify.error({
                    title: this.i18nValues["error"],
                    message: this.i18nValues["userDeletError"],
                    position: "bottom-right",
                  });
                }       
              });
            })
      },

      retrieveUserCount() {
        this.$store
          .dispatch("user/countUsers")
          .then((res) => {
            this.cantidad = res;
          });
      },
  
      profilesFormatter(row) {
        return row.profiles.map((profile) => profile.identification).join(", ");
      },

      handleSortChange(event) {
      const nextProp = event && event.prop ? event.prop : null;
      const nextOrder = event && event.order ? event.order : null;
      const sortChanged =
        this.sortProp !== nextProp || this.sortOrder !== nextOrder;
      this.sortProp = nextProp;
      this.sortOrder = nextOrder;
      if (!sortChanged) {
        return;
      }

      const currentPage =
        this.$refs.pagination && this.$refs.pagination.tableIndex
          ? this.$refs.pagination.tableIndex
          : this.initialPage || 1;
      this.initialPage = currentPage;

      let sorted = null;
      if (
        this.$refs &&
        this.$refs.pagination &&
        typeof this.$refs.pagination.handleSortChangePagination === "function"
      ) {
        sorted = this.$refs.pagination.handleSortChangePagination(event);
      }
      if (!Array.isArray(sorted)) {
        sorted = this.sortUsersLocally(
          this.UsersList,
          this.sortProp,
          this.sortOrder
        );
      }
      if (Array.isArray(sorted)) {
        this.UsersList = sorted;
        this.$nextTick(() => {
          if (
            this.$refs &&
            this.$refs.pagination &&
            typeof this.$refs.pagination.currentChange === "function"
          ) {
            this.$refs.pagination.currentChange(currentPage);
          } else if (Array.isArray(this.UsersList)) {
            const start = (currentPage - 1) * this.pageSize;
            this.UsersSubList = this.UsersList.slice(
              start,
              start + this.pageSize
            );
          }
        });
      }

      this.updateRouteQuery({
        sortProp: this.sortProp || undefined,
        sortOrder: this.sortOrder || undefined,
        page: currentPage,
      });
    },

    applyInitialSort() {
      if (
        !Array.isArray(this.UsersList) ||
        !this.UsersList.length ||
        !this.sortProp ||
        !this.sortOrder
      ) {
        return;
      }
      let sorted = null;
      if (
        this.$refs &&
        this.$refs.pagination &&
        typeof this.$refs.pagination.handleSortChangePagination === "function"
      ) {
        sorted = this.$refs.pagination.handleSortChangePagination(
          { prop: this.sortProp, order: this.sortOrder },
          this.UsersList
        );
      }
      if (!Array.isArray(sorted)) {
        sorted = this.sortUsersLocally(
          this.UsersList,
          this.sortProp,
          this.sortOrder
        );
      }
      if (Array.isArray(sorted)) {
        this.UsersList = sorted;
        this.ensurePaginationSync();
      }
    },

    sortUsersLocally(list, prop, order) {
      if (!Array.isArray(list) || !prop || !order) {
        return list;
      }
      const direction = order === "descending" ? -1 : 1;
      return [...list].sort((a, b) => {
        const aVal = this.getValueByPath(a, prop);
        const bVal = this.getValueByPath(b, prop);
        if (this.isEmptyValue(aVal) && this.isEmptyValue(bVal)) {
          return 0;
        }
        if (this.isEmptyValue(aVal)) {
          return 1;
        }
        if (this.isEmptyValue(bVal)) {
          return -1;
        }
        if (this.isNumericValue(aVal) && this.isNumericValue(bVal)) {
          return (Number(aVal) - Number(bVal)) * direction;
        }
        const comparison = String(aVal).localeCompare(String(bVal), undefined, {
          sensitivity: "base",
        });
        return comparison * direction;
      });
    },

    getValueByPath(item, path) {
      if (!item || !path) {
        return null;
      }
      return path.split(".").reduce((acc, segment) => {
        if (acc === null || acc === undefined) {
          return null;
        }
        return acc[segment];
      }, item);
    },

    isEmptyValue(value) {
      return value === null || value === undefined || value === "";
    },

    isNumericValue(value) {
      if (typeof value === "number") {
        return !isNaN(value);
      }
      if (typeof value === "string" && value.trim() === "") {
        return false;
      }
      return !isNaN(Number(value));
    },

    ensurePaginationSync() {
      this.$nextTick(() => {
        if (
          this.$refs &&
          this.$refs.pagination &&
          typeof this.$refs.pagination.currentChange === "function"
        ) {
          const targetIndex =
            this.$refs.pagination.tableIndex || this.initialPage || 1;
          this.$refs.pagination.currentChange(targetIndex);
        } else if (Array.isArray(this.UsersList)) {
          this.UsersSubList = this.UsersList.slice(0, this.pageSize);
        }
      });
    },

    paginationChange(evt) {
      if (evt && evt.list) {
        this.UsersSubList = evt.list;
      }
      const currentIdx = this.$refs.pagination && this.$refs.pagination.tableIndex ? this.$refs.pagination.tableIndex : this.initialPage;
      this.updateRouteQuery({ page: currentIdx });
    },

    setCurrentPage(idx) {
      if (typeof idx === 'number') {
        this.updateRouteQuery({ page: idx });
      }
    },

    hasFiltersInQuery() {
      const q = this.$route.query || {};
      return !!(
        q.name ||
        q.userId ||
        // Also check component state in case query hasn't updated yet
        (this.filter && this.filter.name) ||
        (this.filter && this.filter.userId)
      );
    },

    runInitialSearch({ preservePage = false } = {}) {
      if (this.hasFiltersInQuery()) {
        this.retrieveUsersBySearch(preservePage);
      } else {
        this.retrieveUsers({
          preservePage,
          targetPage: preservePage ? this.initialPage || 1 : 1,
        });
      }
    },

    // --- Query sync helpers ---
    restoreFromQuery() {
      const q = this.$route.query || {};
      this.filter = this.filter || {};
      this.filter.name = q.name || null;
      this.filter.userId = q.userId || null;
      this.initialPage = q.page ? Number(q.page) : 1;
      this.sortProp = q.sortProp || null;
      this.sortOrder = q.sortOrder || null;
    },

    updateRouteQuery(partial) {
      const base = this.buildQueryFromState();
      const next = Object.assign({}, base, partial || {});
      const cleaned = {};
      Object.keys(next).forEach(k => {
        const v = next[k];
        if (v !== undefined && v !== null && v !== '') cleaned[k] = v;
      });
      this.isUpdatingRoute = true;
      const done = () => { this.$nextTick(() => { this.isUpdatingRoute = false; }); };
      this.$router.replace({ query: cleaned }).then(done).catch(done);
    },

    buildQueryFromState() {
      const q = {};
      if (this.filter && this.filter.name) q.name = this.filter.name;
      if (this.filter && this.filter.userId) q.userId = this.filter.userId;
      if (this.$refs && this.$refs.pagination && this.$refs.pagination.tableIndex) q.page = this.$refs.pagination.tableIndex;
      else if (this.initialPage) q.page = this.initialPage;
      if (this.sortProp) q.sortProp = this.sortProp;
      if (this.sortOrder) q.sortOrder = this.sortOrder;
      return q;
    },
  },
  
  };
  
  </script>

<style scoped>
.filters-wrapper {
  margin-bottom: 20px;
}

.filters-row {
  display: flex;
  gap: 15px;
  align-items: flex-end;
  flex-wrap: wrap;
}

.filters-row .el-form-item {
  margin-bottom: 0;
  flex-shrink: 0;
}

.filters-row .el-input,
.filters-row .el-select {
  width: 180px;
}

.filters-row .el-input >>> .el-input__inner,
.filters-row .el-select >>> .el-input__inner {
  border: 1px solid #dcdfe6;
}

.filters-row .el-date-editor {
  width: 180px;
}

.filters-row .el-date-editor >>> .el-input__inner {
  border: 1px solid #dcdfe6;
}

.filters-row .el-button {
  flex-shrink: 0;
}

/* Pagination + results inline */
.pagination-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 0 20px 10px;
  color: #606266;
}

.results-info {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;
}

.results-info p {
  margin: 0;
  font-size: 12px;
  color: #606266;
  font-weight: 500;
}
</style>